module.exports = __webpack_public_path__ + "img/43.2afa2f26.jpg";